import React from 'react';
import { getOutcomeSpread } from '../data/utils/getOutcomeSpread';
import OddWrapper from './OddWrapper';

function InnerOdd(props) {
    let classes = '';
    if (props.selected) {
        classes += ' selected';
    }
    if (props.betData.pClass != null) {
        classes += ' ' + props.betData.pClass;
    }
    let dia = props.dia ? props.dia : props.betData.dia;

    return (
        <div className={"banner-odd" + classes} onClick={props.onClick}>
            <span>{((getOutcomeSpread(props.betData.handicap, props.betData.tipoHandicap, null, dia) !== '' &&
                    getOutcomeSpread(props.betData.handicap, props.betData.tipoHandicap, null, dia) !== '0' && props.betData.tipoHandicap !== 5 && props.betData.tipoHandicap !== 7) && !props.compactView) ?
                    props.desc + " (" + getOutcomeSpread(props.betData.handicap, props.betData.tipoHandicap, null, dia) + ")" :
                    props.desc}</span>
            {props.value != null ?
                <span>{props.value}</span>
                :
                <span>&#128274;</span>
            }
        </div>
    );
}

function BannerOdd(props) {
    return <OddWrapper {...props} render={InnerOdd} />;
}

export default BannerOdd;